import { Currency } from '@/core/currency/interfaces';

const NPR: Currency = {
    name: 'Nepalese Rupee',
    demonym: 'Nepalese',
    majorSingle: 'Rupee',
    majorPlural: 'Rupees',
    codeNumeric: '524',
    symbol: 'Rs.',
    symbolNative: 'रू',
    minorSingle: 'Paisa',
    minorPlural: 'Paise',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'NPR',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default NPR;
